import React, { useEffect, useState } from "react";
import StarRatings from "react-star-ratings";
import { homepagee as homepage, apiRoot,ddns}  from "../../../package.json";

import { Document, Page } from "react-pdf/dist/esm/entry.webpack";
import { pdfjs } from "react-pdf";

import { Button, Card, CardHeader, CardBody, FormGroup, Form, Input, Row, Col, Modal} from "reactstrap";
import { getAll, userFiles, savePrivateInfo, sendMailNextFase, deleteUser} from "network/ApiAxios";
import axios from "axios";

const EditUserFull = (props) => {
  const [user, setUser] = useState([]);
  const [rate, setRate] = useState();
  const [rate2, setRate2] = useState();
  const [notes, setnotes] = useState();
  const [payrate, setPayRate] = useState();
  const [active, setActive] = useState();
  const [sDate, setsDate] = useState();
  const [eDate, seteDate] = useState();
  const [msg, setMsg] = useState();
  const [upload, setUpload] = useState();
  const [role, setRole] = useState();
  const [cv, setCV] = useState();
  const [pic, setPic] = useState('');
  const [videoModal, setVideoModal] = useState(false);
  const [videoURL, setVideoURL] = useState('');
  
  const toggleVideoModal = () => setVideoModal(!videoModal);

  const currentRole = JSON.parse(localStorage.getItem('user')).role
  

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
    const userID = props.userID;
    videoCheck()
    const runAsync = async () => {
      pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
      const response = await getAll(userID);
      console.log(response)
      setMsg(response.data.users[0].nextfase);
      setUser(response.data.users[0]);
      setCV(ddns + "/userfiles/"+ response.data.users[0].email +"/pics/CV-" + response.data.users[0]._id + ".pdf");
      setRate(response.data.users[0].rate);
      setRate2(response.data.users[0].rate2);
      if (response.data.users[0].picture) {
        const dat = response.data.users[0].picture;
        setPic(ddns + '/userfiles/' + response.data.users[0].email + '/pics/' + dat);
      } else {
        setPic(require("assets/img/theme/team-1-800x800.jpg").default);
      }
    };
    runAsync();
    // eslint-disable-next-line
  }, []);

  const saveUser = async (e) => {
    e.preventDefault();
    const res = await savePrivateInfo(
      {userID:user._id,
      rate,
      rate2,
      notes,
      payrate,
      active,
      sDate,
      eDate,
      role}
    );
    console.log(res);
    if (res.data.success) {
      //history.replace("/admin/index");
      history.go(0)
    }else{
      console.log(res)
    }
  };

  const sendMail = async () => {
    var res = await sendMailNextFase(user._id, user.email, user.name);
    if (res.data.success) {
      setMsg(true);
    }
  };

  const uploadFile = async (e) => {
    setUpload("File is uploading....");
    const files = new FormData();
    files.append("doc", e.target.files[0]);
    files.append("userID", user._id);
    files.append("email", user.email);
    var resp = await userFiles(files);
    if (resp.data.success) {
      setUpload("You can now upload more files");
    }
  };

  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  function nextPage() {
    if (pageNumber < numPages) {
      setPageNumber(pageNumber + 1);
    }
  }

  function previousPage() {
    if (pageNumber >= numPages) {
      setPageNumber(pageNumber - 1);
    }
  }

  const handleDeleteUser = async()=>{
    const resp = await deleteUser(user._id)
    if(resp.data.success){
      history.go(0)
    }else{alert('Something went wrong while deleting the user')}
  }

  const videoCheck = ()=>{
    const path = 'https://celebrationjump.com/userfiles/cvs/videoCV-'+ props.userID + '.webm'
    axios
    .get(path)
    .then((data) => {
        if(data.headers['content-type']== "video/webm"){
            setVideoURL(path)
            return <Button onClick={()=> setVideoModal(true)}>Watch Video</Button>
        }else{
            return ''
        }
    })
    .catch(() => {
        return '';
    });
  }

  return (
    <>
        <Row>
          <div className="col">
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                <Col xs="4">
                  { currentRole == 'admin' && <Button className="btn-danger ml-4 mb-2" size="sm" onClick={handleDeleteUser}>
                      Delete User
                    </Button> }
                  </Col>
                  <Col xs="4" className="text-center">
                    <h3 className="mb-0"> User information </h3>
                  </Col>
                  <Col className="text-right" xs="4">
                    {currentRole == 'admin' ? <Button
                      color="primary"
                      type="submit"
                      form="myform"
                      size="sm"
                    >
                      Save
                    </Button> : null}
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Form id="myform" onSubmit={saveUser}>
                  <div className="pl-lg-4">
                    <h6 className="heading-small text-muted mb-4">
                      User information
                    </h6>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-username"
                          >
                            Username
                          </label>
                          <p></p>
                          <label>{user.name}</label>
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-email"
                          >
                            Email address
                          </label>
                          <p></p>
                          <a href={"mailto:" + user.email}>{user.email}</a>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-phone"
                          >
                            Phone Number
                          </label>
                          <p></p>
                          <a href={"tel:" + user.phone}>{user.phone}</a>
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-birthday"
                          >
                            Birthday
                          </label>
                          <p></p>
                          <label>
                            {new Date(user.birthday).toDateString()}
                          </label>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg='6'></Col>
                      <Col lg="6" >
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-profilepicture"
                          >
                            Profile Picture
                          </label>
                          <p></p>
                          <img
                            alt="..."
                            className="form-control-alternative ml-5"
                            style={{ height: "150px" }}
                            src={pic}
                            id="input-profilepicture"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <hr></hr>
                    <h6 className="heading-small text-muted mb-4">
                      User Address
                    </h6>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-adress"
                          >
                            Address
                          </label>
                          <p></p>
                          <label>{user.adress}</label>
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <label
                          className="form-control-label"
                          htmlFor="input-country"
                        >
                          Country
                        </label>
                        <p></p>
                        <label>{user.country}</label>
                      </Col>
                    </Row>
                    <hr></hr>
                    <h6 className="heading-small text-muted mb-4">
                      User social information
                    </h6>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-facebook"
                          >
                            Facebook
                          </label>
                          <p></p>
                          <a href={user.facebook} target="_blank" rel="noreferrer">
                            Facebook Link
                          </a>
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-instagram"
                          >
                            Instagram
                          </label>
                          <p></p>
                          <a href={user.instagram} target="_blank" rel="noreferrer">
                            Instagram Link
                          </a>
                        </FormGroup>
                      </Col>
                    </Row>
                    <hr></hr>
                    <h6 className="heading-small text-muted mb-4">
                      User ID and Drivers license
                    </h6>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-idpicture"
                          >
                            ID picture
                          </label>
                          <p></p>
                          <img
                            alt="..."
                            className="form-control-alternative"
                            style={{ height: "150px" }}
                            src={
                              user.IDpicture ? apiRoot + '/userfiles/' + user.email + '/pics/' + user.IDpicture : ""
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-driverlicense"
                          >
                            Picture Drivers License
                          </label>
                          <p></p>
                          <img
                          alt="..."
                            className="form-control-alternative"
                            style={{ height: "150px" }}
                            src={
                              user.driverlicense
                                ? apiRoot + '/userfiles/' + user.email + '/pics/' + user.driverlicense
                                : ""
                            }
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <hr></hr>
                    <h6 className="heading-small text-muted mb-4">
                      Private information(ADMINS ONLY)
                    </h6>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-driverlicense"
                          >
                            Rating 1
                          </label>
                          <p></p>
                          <StarRatings
                            rating={rate ? rate : 0}
                            starRatedColor="blue"
                            changeRating={setRate}
                            numberOfStars={5}
                            name="rating"
                            starDimension="30px"
                            starSpacing="2px"
                            onChange={(e) => setRate(e.target.value)}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-driverlicense"
                          >
                            Rating 2
                          </label>
                          <p></p>
                          <StarRatings
                            rating={rate2 ? rate2 : 0}
                            starRatedColor="blue"
                            changeRating={setRate2}
                            numberOfStars={5}
                            name="rating"
                            starDimension="30px"
                            starSpacing="2px"
                            onChange={(e) => setRate2(e.target.value)}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-payrate"
                          >
                            Pay Rate(hourly)
                          </label>
                          <p></p>
                          <Input
                            className="form-control-alternative"
                            value={user.payrate}
                            id="input-payrate"
                            placeholder="Pay Rate(hourly)"
                            onChange={(e) => setPayRate(e.target.value)}
                            type="number"
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          
                          <Input
                            className="form-control-alternative"
                            style={{
                              height: "25px",
                              width: "25px",
                              //left: "50%",
                            }}
                            value={user.active}
                            onChange={(e) => setActive(e.target.value)}
                            type="checkbox"
                            id='activechk'  
                            />
                            <p></p>
                          <label
                            className="form-control-label"
                            htmlFor="activechk"
                            
                          >
                            Enable/Disable User
                          </label>
                          <p></p>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-Accomodation"
                          >
                            Accomodation
                          </label>
                          <p></p>
                          <label>Room number:{user.accomodation}</label>
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-Documents"
                          >
                            Upload Documents to user{" "}
                            {upload ? (
                              <span style={{ color: "green" }}> {upload} </span>
                            ) : (
                              ""
                            )}
                          </label>
                          <Input
                            className="form-control-alternative"
                            id="input-Documents"
                            placeholder="Upload Documents"
                            //value={user.instagram}
                            onChange={uploadFile}
                            type="file"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-idpicture"
                          >
                            Role
                          </label>
                          <Input
                            type="select"
                            name="select"
                            id="exampleSelect"
                            onChange={(e) => setRole(e.target.value)}
                          >
                            <option>Select 1</option>
                            <option>admin</option>
                            <option>user</option>
                            <option>seller</option>
                            <option>shop</option>
                            <option>manager</option>
                            <option>sellermanager</option>
                            <option>cleaner</option>
                            <option>security</option>
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-idpicture"
                          >
                            Private Notes
                          </label>
                          <Input
                            className="form-control-alternative"
                            value={user.notes}
                            id="input-birthday"
                            onChange={(e) => setnotes(e.target.value)}
                            type="textarea"
                            style={{ height: "100px" }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <hr></hr>
                    <h6 className="heading-small text-muted mb-4">
                      Job Applicants CVS(ADMINS ONLY)
                    </h6>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-driverlicense"
                          >
                            Position
                          </label>
                          <p></p>
                          <label>{user.position}</label>
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-driverlicense"
                          >
                            Years of Experience
                          </label>
                          <p></p>
                          <label>{user.exp}</label>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-driverlicense"
                          >
                            Goes to the Next Fase? (This button will send an
                            automated email saying that he will be going to the
                            next fase)
                          </label>
                          <p></p>
                          <Button
                            color="primary"
                            className="form-control-alternative"
                            onClick={sendMail}
                            hidden={msg}
                          >
                            Send Email
                          </Button>
                          {msg ? (
                            <>
                              <h5 className="mb-2" style={{height: "50px",display: "inline-flex",alignItems: "right",justifyContent: "center"}}>
                                Already in the next fase
                              </h5>
                              {videoURL && <Row>
                                  <Button className=" btn-info ml-4" onClick={()=> setVideoModal(true)}>Watch Video</Button>
                                </Row>}
                            </>
                          ) : (
                            ""
                          )}
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-driverlicense"
                          >
                            Arrival Date
                          </label>
                          <label className="float-right">
                            {new Date(user.sDate).toDateString()}
                          </label>
                          <p></p>
                          <Input
                            className="form-control-alternative"
                            //value={birthday}
                            onChange={(e) => setsDate(e.target.value)}
                            type="date"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-driverlicense"
                          >
                            Languages
                          </label>
                          <p></p>
                          <label>English-{user.enLang}</label>
                          <p></p>
                          <label>Portuguese-{user.ptLang}</label>
                          <p></p>
                          <label>Dutch-{user.nlLang}</label>
                          {user.otherLang && user.otherLang.map((langItem)=>{
                            return <><p></p><label>{langItem}</label></>
                          })}
                          
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-driverlicense"
                          >
                            Departing Date
                          </label>
                          <label className="float-right">
                            {new Date(user.eDate).toDateString()}
                          </label>
                          <p></p>
                          <Input
                            className="form-control-alternative"
                            //value={birthday}
                            onChange={(e) => seteDate(e.target.value)}
                            type="date"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-driverlicense"
                          >
                            About
                          </label>
                          <p></p>
                          <label>{user.about}</label>
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                          >
                            Where you ear about us
                          </label>
                          <label>{user.aboutUs}</label>
                          <p></p>
                          <label
                            className="form-control-label"
                          >
                            Prefered workplace
                          </label>
                          <p></p>
                          <label>{user.workplace}</label>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row className="justify-content-center">
                      <Button
                        href={cv}
                        download
                        target="_blank" 
                        rel="noreferrer"
                        className='mb-4'
                        color="primary"
                      >
                        Open CV
                      </Button>
                      <div>
                        <Document
                          file={cv}
                          onLoadSuccess={onDocumentLoadSuccess}
                        >
                          <Page
                            pageNumber={pageNumber}
                            width={
                              window.innerWidth > 1000
                                ? window.innerWidth - 350
                                : window.innerWidth - 100
                            }
                          />
                          <Row
                            className="absolute-center"
                            style={{
                              justifyContent: "center",
                              position: "sticky",
                              bottom: "100px",
                              backgroundColor: '#1386ee',
                              paddingBottom: '10px',
                              paddingTop: '10px'
                            }}
                          >
                            <Button
                              onClick={previousPage}
                              className="float-left"
                              style={{
                                right: "20%",
                                display: numPages === 1 ? "none" : "block",
                              }}
                            >
                              {" "}
                              Previous Page{" "}
                            </Button>
                            Page {pageNumber} of {numPages}
                            <Button
                              onClick={nextPage}
                              className="float-right"
                              style={{
                                left: "15%",
                                display: numPages === 1 ? "none" : "block",
                              }}
                            >
                              {" "}
                              Next Page{" "}
                            </Button>
                          </Row>
                        </Document>
                      </div>
                    </Row>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Row>
        <Modal isOpen={videoModal} toggle={toggleVideoModal}  >
            {
              videoModal && <video controls src={'https://celebrationjump.com/userfiles/cvs/videoCV-' + props.userID + '.webm'} />
            }
        </Modal>
    </>
  );
};

export default EditUserFull;
